import {
    BULK_ADD_DRIVERID_TAGS_OPEN_MODAL,
    BULK_ADD_DRIVERID_TAGS_CLOSE_MODAL,
    BULK_ADD_DRIVERID_TAGS_VALIDATE_REQUEST,
    BULK_ADD_DRIVERID_TAGS_VALIDATE_RESULT,
    BULK_ADD_DRIVERID_TAGS_IMPORT_REQUEST,
    BULK_ADD_DRIVERID_TAGS_IMPORT_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    importResult: null,
    validationResult: null,
    error: null
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {

        case BULK_ADD_DRIVERID_TAGS_OPEN_MODAL:
            return { ...state, openModal: true }

        case BULK_ADD_DRIVERID_TAGS_CLOSE_MODAL:
            return { ...state, openModal: false }


        case BULK_ADD_DRIVERID_TAGS_VALIDATE_REQUEST:
            return { ...state, loading: true }

        case BULK_ADD_DRIVERID_TAGS_VALIDATE_RESULT:
            return { ...state, loading: false, validationResult: action.payload }


        case BULK_ADD_DRIVERID_TAGS_IMPORT_REQUEST:
            return { ...state, loading: true }

        case BULK_ADD_DRIVERID_TAGS_IMPORT_RESULT:
            return { ...state, loading: false, importResult: action.payload }

        case CLEAR_REDUX:
            return ["", "BULK_ADD_DRIVERID_TAGS"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};